import { GoldButton } from './Shared';
import { CopyIcon } from './Icons';

/* Referral card: copyable code plus the share CTA. */
export default function ShareCard({ code, onCopy, onShare }) {
  return (
    <div className="gq-share">
      <div className="gq-t gq-ttl">Share With Friends</div>
      <div className="gq-sub">Friends who join with your code count toward your Referrals streak. No limit on Gems.</div>
      <button type="button" className="gq-code" onClick={onCopy} aria-label={`Copy code ${code}`}>
        <span>{code}</span>
        <CopyIcon />
      </button>
      <GoldButton onClick={onShare}>Share Now</GoldButton>
    </div>
  );
}
